// extracted by mini-css-extract-plugin
export default {"logo":"InSiteLogo_logo__MmATO"};